export default () => ({
  courses               : [],
  newCourse             : '',
  course                : '',
  userPermissions       : [],
  institutionTemplateId : null
});
